// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios';
Vue.prototype.$windowWidth = 0;
axios.defaults.timeout = 5000;
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8';
axios.interceptors.request.use(
  config => {
  //'http://47.94.156.156:8080/updateImage'
  config.data = JSON.stringify(config.data);
console.log(config.data)
config.url="http://47.94.156.156:8080"+config.url
return config;
},
error => {
  return Promise.reject(error.response);
});
Vue.prototype.language = 'ENG' 
router.beforeEach((to,from,next)=>{
  console.log('321')
  var path = to.path
  var t1 = path.indexOf('/en') !=-1
  console.log(t1)
  if(t1){
    localStorage.setItem('language','EN')
  }else{
    localStorage.setItem('language','CN')
  }
  next();
})
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.prototype.$axios=axios
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js